import styled from '@emotion/styled';
import { Theme } from '@nykaa/ui-components/themes/types';

export const InteractiveFocusScope = styled.div`
  width: 100%;
  a[href]:focus-visible,
  select:focus-visible,
  summary:focus-visible,
  [role='link']:focus-visible,
  [role='tab']:focus-visible,
  [role='menuitem']:focus-visible,
  [role='switch']:focus-visible,
  [role='checkbox']:focus-visible,
  [role='radio']:focus-visible,
  [role='slider']:focus-visible,
  [role='spinbutton']:focus-visible,
  [tabindex]:not([tabindex='-1']):focus-visible {
    outline: 2px solid ${({ theme }: { theme: Theme }) => theme?.colors?.primary};
  }

  button:focus-visible, [role='button']:focus-visible {
    outline: 2px solid ${({ theme }: { theme: Theme }) => theme?.colors?.black100};  
  }
  
`;